// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609240735/js/" + chunkId + "." + {"44":"f97d0265","225":"4ceadffd","481":"29e38f1e","486":"6d0575d4","770":"75f55261"}[chunkId] + ".0.2319318370195561.chunk.js";
};